module.exports = __webpack_public_path__ + "static/media/Kiosk.2ab08f9b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/iLocal-Delivery-Icons/Kiosk.svg
// module id = 13535
// module chunks = 0